module.exports = __webpack_public_path__ + "img/analytics-orange.14bc16e0.svg";